import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Grid from '@mui/material/Grid';
import { PhotoEvent } from 'common-models';
import { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGetSingleEventWithParentsQuery } from '../../features/events/eventsApiSlice';


type EventsBreadCrumbProps = {
    event?: PhotoEvent;
}


const EventsBreadCrumb: FC<EventsBreadCrumbProps> = ({ event }) => {
    const { data: eventWithParents } = useGetSingleEventWithParentsQuery({ eventId: event?.id ?? '' });

    const [crumbs, setCrumbs] = useState([] as Array<React.JSX.Element>);

    useEffect(() => {

        if (eventWithParents) {
            const crumbItems: Array<React.JSX.Element> = []

            if (!event) {
                return;
            }

            let currentEvent: PhotoEvent | undefined = event;
            crumbItems.push(<Grid size="auto" key={currentEvent.id} > <ChevronRightIcon sx={{ color: 'text.secondary', fontSize: '1.2rem', mx: 0.5, verticalAlign: 'middle' }} /> {currentEvent.title}</Grid >)

            while (currentEvent?.parentEventId) {
                const localEvent: PhotoEvent = currentEvent;

                const parentEvent = eventWithParents.find(x => x.id === localEvent.parentEventId);
                if (parentEvent) {
                    crumbItems.push(<Grid size="auto" key={parentEvent.id}> <ChevronRightIcon sx={{ color: 'text.secondary', fontSize: '1.2rem', mx: 0.5, verticalAlign: 'middle' }} /> <Link to={`/events/${parentEvent.id}`}>{parentEvent.title}</Link></Grid>)
                }

                currentEvent = parentEvent;
            }

            setCrumbs(crumbItems.reverse());
        }
    }, [event, eventWithParents])


    return <Grid container sx={{
        alignItems: 'center',
    }}><Link to='/events'>Events</Link>{crumbs}</Grid>

}

export { EventsBreadCrumb };
